import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=a390f5b6"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports